import de_general from './de/general.json'
import de_privacy from './de/privacy.json'
import en_general from './en/general.json'
import en_privacy from './en/privacy.json'
import en_help from './en/help.json'

export default {
  de: { ...de_general, ...de_privacy, help: en_help },
  en: { ...en_general, ...en_privacy, help: en_help }
}
